import React from 'react'

export default function SolutionIssueType() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24.077 1H7.92309C4.09958 1 1 4.09959 1 7.92309V24.077C1 27.9006 4.09958 31 7.92309 31H24.077C27.9006 31 31 27.9006 31 24.077V7.92309C31 4.09959 27.9006 1 24.077 1Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1 16.0467H10.2308L13.6923 10.2544L17.1538 22.9467L21.7693 16.0467H31" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
